const progressContainer = document.querySelector(
  ".rt-delivery-rate-main .progress-container"
);
function setPercentage() {
  if (progressContainer.getAttribute("data-percentage")) {
    const percentage = progressContainer.getAttribute("data-percentage") + "%";
    const progressEl = progressContainer.querySelector(
      ".rt-delivery-rate-main .progress"
    );
    progressEl.style.width = percentage;
  }
}
if (progressContainer) {
  setPercentage();
}

jQuery(document).ready(function ($) {
  $(
    ".template-cart .shop_table th.product-delete-checkbox input[type=checkbox]"
  ).click(function () {
    $("input[type=checkbox]").prop("checked", $(this).prop("checked"));
  });

  $(
    ".template-cart .shop_table tr td.product-delete-checkbox input[type=checkbox]"
  ).click(function () {
    if (!$(this).prop("checked")) {
      $("th.product-delete-checkbox input[type=checkbox]").prop(
        "checked",
        false
      );
    }
  });
  function removeItemFromCartPage() {
    var dataR = { updates: {} };
    $(
      ".template-cart .shop_table tr td.product-delete-checkbox input[type=checkbox]:checked"
    ).each(function () {
      var itemId = parseInt($(this).attr("itemId"));
      dataR.updates[itemId] = 0;
    });
    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: dataR,
      dataType: "json",
      success: function () {
        location.reload();
      },
    });
  }
  $(".template-cart .shop_table th.product-delete-trash .remove-product").click(
    function () {
      if (
        $(
          ".template-cart .shop_table tr td.product-delete-checkbox input[type=checkbox]:checked"
        ).length > 0
      ) {
        removeItemFromCartPage();
      } else {
        alert("Please select item !");
      }
    }
  );
});
